import { Box } from '@mui/material'
import { TypographySecondary14 } from 'ui/typography/TypographySecondary14'
interface NoDataBlockProps {
	margin?: string
}
const NoDataBlock = ({ margin }: NoDataBlockProps) => {
	return (
		<Box
			sx={{
				margin: margin ? margin : '30% 0 0 0',
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
				gap: '4px',
			}}
		>
			<TypographySecondary14>Нет данных</TypographySecondary14>
			<TypographySecondary14 sx={{ textAlign: 'center' }}>
				Нет данных, соответствующих заданным условиям
			</TypographySecondary14>
		</Box>
	)
}
export default NoDataBlock
